"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ContactPersonModel = function ContactPersonModel(json, lang) {
  var data = [];
  if (json.enterprise_persons.length > 0) {
    json.enterprise_persons.forEach(function (item) {
      var model = {
        name: '',
        avatar: '',
        department: '',
        mail: '',
        functionTitle: '',
        telephone: '',
        mobile_phone: '',
        fax: '',
        social_media: [],
        appointment: '',
        irea: '',
        biv: ''
      };
      model.name = item.contact_person.first_name + ' ' + item.contact_person.last_name;
      model.functionTitle = item.function_title.name;
      if (item.avatar) {
        model.avatar = item.avatar;
      } else {
        if (item.contact_person.avatar) {
          model.avatar = item.contact_person.avatar;
        }
      }
      if (item.contact_person.biv) {
        model.biv = item.contact_person.biv;
      }
      if (item.contact_person.personal_contact_methods.length > 0) {
        item.contact_person.personal_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      if (item.business_contact_methods.length > 0) {
        item.business_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      data.push(model);
    });
  }
  if (json.establishment_persons.length > 0) {
    json.establishment_persons.forEach(function (item) {
      var model = {
        name: '',
        avatar: '',
        department: '',
        mail: '',
        functionTitle: '',
        telephone: '',
        mobile_phone: '',
        fax: '',
        social_media: [],
        appointment: '',
        irea: '',
        biv: ''
      };
      model.name = item.contact_person.first_name + ' ' + item.contact_person.last_name;
      model.functionTitle = item.function_title;
      if (item.avatar) {
        model.avatar = item.avatar;
      } else {
        if (item.contact_person.avatar) {
          model.avatar = item.contact_person.avatar;
        }
      }
      if (item.contact_person.biv) {
        model.biv = item.contact_person.biv;
      }
      if (item.contact_person.personal_contact_methods.length > 0) {
        item.contact_person.personal_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      if (item.business_contact_methods.length > 0) {
        item.business_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      data.push(model);
    });
  }
  if (json.group_persons.length > 0) {
    json.group_persons.forEach(function (item) {
      var model = {
        name: '',
        avatar: '',
        department: '',
        mail: '',
        functionTitle: '',
        telephone: '',
        mobile_phone: '',
        fax: '',
        social_media: [],
        appointment: '',
        irea: '',
        biv: ''
      };
      model.name = item.contact_person.first_name + ' ' + item.contact_person.last_name;
      model.functionTitle = item.function_title.name;
      if (item.avatar) {
        model.avatar = item.avatar;
      } else {
        if (item.contact_person.avatar) {
          model.avatar = item.contact_person.avatar;
        }
      }
      if (item.contact_person.biv) {
        model.biv = item.contact_person.biv;
      }
      if (item.contact_person.personal_contact_methods.length > 0) {
        item.contact_person.personal_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      if (item.business_contact_methods.length > 0) {
        item.business_contact_methods.forEach(function (method) {
          switch (method.medium) {
            // General items
            case 'Email':
              model.email = method.value;
              break;
            case 'Mobile':
              model.mobile_phone = method.value;
              break;
            case 'Fixed':
              model.telephone = method.value;
              break;
            case 'Fax':
              model.fax = method.value;
              break;
            case 'Facebook':
              model.social_media.push({
                name: 'facebook',
                value: method.value
              });
              break;
            case 'Instagram':
              model.social_media.push({
                name: 'instagram',
                value: method.value
              });
              break;
            case 'LinkedIn':
              model.social_media.push({
                name: 'linkedin',
                value: method.value
              });
              break;
            case 'Pinterest':
              model.social_media.push({
                name: 'pinterest',
                value: method.value
              });
              break;
            case 'Twitter':
              model.social_media.push({
                name: 'twitter',
                value: method.value
              });
              break;
            case 'Website':
              model.social_media.push({
                name: 'website',
                value: method.value
              });
              break;
            case 'WhatsApp':
              model.social_media.push({
                name: 'whatsapp',
                value: method.value
              });
              break;
            case 'YouTube':
              model.social_media.push({
                name: 'youtube',
                value: method.value
              });
              break;
            case 'Appointment':
              model.appointment = method.value;
          }
        });
      }
      data.push(model);
    });
  }
  return data;
};
var _default = exports["default"] = ContactPersonModel;